import React from "react";
import { cn } from "@/lib/utils";

interface FilterFieldProps {
  label: string;
  children: React.ReactNode;
  className?: string;
  icon?: React.ComponentType<{ className?: string }>;
  variant?: "listing" | "hero" | "inline";
}

export default function FilterField({ label, children, className, icon: Icon, variant = "listing" }: FilterFieldProps) {
  const isHero = variant === "hero";

  if (isHero) {
    return (
      <div className={cn(
        "flex items-center gap-3 px-3.5 py-2.5 rounded-xl border border-cream-200 bg-cream-50 min-w-0 w-full transition-all hover:border-heat-300 group sm:w-auto sm:min-w-[160px]",
        className
      )}>
        {Icon ? (
          <Icon className="w-4 h-4 text-heat-500 shrink-0" />
        ) : (
          <span className="text-[10px] font-bold uppercase tracking-widest text-heat-700 shrink-0 group-hover:text-heat-800 transition-colors pr-1.5 border-r border-cream-200/50 mr-0.5">
            {label}
          </span>
        )}
        <div className="flex-1 min-w-0 flex items-center">
          {children}
        </div>
      </div>
    );
  }

  return (
    <div className={cn(
      "flex items-center gap-3 px-3.5 py-2.5 rounded-xl border border-cream-200 bg-cream-50 min-w-0 w-full transition-all hover:border-heat-300 group sm:w-auto sm:min-w-[160px]",
      className
    )}>
      {Icon ? (
        <Icon className="w-4 h-4 text-heat-500 shrink-0" />
      ) : (
        <span className="text-[10px] font-bold uppercase tracking-widest text-heat-700 shrink-0 group-hover:text-heat-800 transition-colors pr-1.5 border-r border-cream-200/50 mr-0.5">
          {label}
        </span>
      )}
      <div className="flex-1 min-w-0 flex items-center">
        {children}
      </div>
    </div>
  );
}